<h2 *ngIf="textStyle === 'tt'">
    {{ text | titlecase }}
</h2>

<h2 *ngIf="textStyle === 'ttb'">
    <strong>{{ text | titlecase }}</strong>
</h2>

<h2 *ngIf="textStyle === 'u'">
    {{ text | uppercase }}
</h2>

<h2 *ngIf="textStyle === 'b'">
    <strong>{{ text }}</strong>
</h2>

<h2 *ngIf="textStyle === 'ub'">
    <strong>{{ text | uppercase }}</strong>
</h2>
